import React from 'react'
import UserNameIdUpdate from './user-update-name-id/index'
import UserUpdateEmail from './user-update-email/index'

const UpdateAttributes = ({ onClickCancel, onUploadStart }) => {
  return (
    <div>
      <UserNameIdUpdate onClickCancel={onClickCancel} onUploadStart={onUploadStart} />
      <UserUpdateEmail onClickCancel={onClickCancel} onUploadStart={onUploadStart} />
    </div>
  )
}

export default UpdateAttributes
